export enum COUNTRY_CODES {
    AUSTRALLIA = 'AU',
    INDONESIA = 'ID'
}